<template>
  <div class="m-container">
    <div class="owl-carousel sponsors owl-theme sponsors" v-if="sponsors.length > 0">
      <a v-for="sponsor in sponsors" :key="sponsor.id" :href="sponsor.link">
        <img :src="sponsor.image" alt="">
      </a>
    </div>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
  name: "Sponsors",
  components: {carousel},
  data() {
    return {
      sponsors: []
    }
  },
  mounted() {
    this.$API.general.getSponsors()
        .then(response => {
          this.sponsors = response;
          setTimeout(function () {
            $('.owl-carousel.sponsors').owlCarousel({
              loop: false,
              margin: 0,
              nav: false,
              responsive: {
                0: {
                  items: 2
                },
                500: {
                  items: 3,
                },
                1000: {
                  items: 5,
                }
              },
              // mouseDrag: false,
            })
          }, 0)
        })
  }
}
</script>

<style scoped>

.sponsors {
  margin-bottom: 30px;
  padding: 30px 0;
  border-bottom: 1px solid #DBE3EB;
  border-top: 1px solid #DBE3EB;
}

.sponsors > div {
  text-align: center;
  margin-bottom: 20px;
}

.sponsors a {
  display: flex;
  overflow: hidden;
  margin: 10px;
  justify-content: center;
}

.sponsors img {
  height: 150px;
  /*width: 100%;*/
  width: auto !important;
  transition: all ease-in-out 0.2s;
}

</style>